export { default as FaqDetail } from './components/FaqDetail/FaqDetail';
export type { FaqDetailProps } from './components/FaqDetail/FaqDetail';
export { default as FaqTagList } from './components/FaqTagList/FaqTagList';
export type { FaqTagListProps } from './components/FaqTagList/FaqTagList';
export { default as FaqList } from './components/FaqList/FaqList';
export type { FaqListProps } from './components/FaqList/FaqList';
export { default as FaqSearchForm } from './components/FaqSearchForm/FaqSearchForm';
export type { FaqSearchFormProps } from './components/FaqSearchForm/FaqSearchForm';
export * from './types';
export * from './api/getFaqDetail';
export * from './api/getFaq';
